'use strict';
(function (module) {
    module.factory('exportService', [
        '$rootScope',
        '$http',
        '$timeout',
        'BASE_EXPORT_URL',
        'reporting.dashboards.services.widgetStatusManager',
        'utils',
        'constants',
        function ($rootScope, $http, $timeout, BASE_EXPORT_URL, WidgetStatusManager, utils, constants) {
            var exports = {};
            exports.getExportStatus = function (containerId, namespace, key) {
                var url = BASE_EXPORT_URL + '/containers/' + containerId + '/namespace/' + namespace + '/key/' + key + '/status';
                return $http.get(url);
            };
            exports.enqueueExport = function (options) {
                var url = BASE_EXPORT_URL + '/containers/' + options.containerId;
                return $http.post(url, options);
            };
            exports.getDownloadUrl = function (containerId, namespace, key) {
                var url = BASE_EXPORT_URL + '/containers/' + containerId + '/namespace/' + namespace + '/key/' + key;
                return url;
            };
            exports.downloadExport = function (containerId, namespace, key) {
                var url = exports.getDownloadUrl(containerId, namespace, key);
                // Using Iframe to get around referral URL problem that a tag causes
                $('<iframe></iframe>')
                    .attr({
                    src: url,
                    style: 'visibility:hidden; display: none;'
                })
                    .appendTo('body');
            };
            var extractWidgets = function (container, extractFn) {
                var ripsawIds = _.reduce(container.pages, function (acc, page) {
                    var ripsawIds = _.map(page.widgets, function (widget) {
                        return extractFn(page, widget);
                    });
                    return acc.concat(ripsawIds);
                }, []);
                return ripsawIds;
            };
            exports.extractRipsawIds = function (container) {
                var extractFn = function (page, widget) {
                    return {
                        widgetId: widget._id,
                        pageId: page._id,
                        containerId: container._id
                    };
                };
                return extractWidgets(container, extractFn);
            };
            /*
             * containerId = 'C456a'
             * pages = [{
             *   _id: 'P5650',
             *   widgets: [{
             *     _id: 'W9865',
             *     _type: 'table'
             *   }, {
             *     _id: 'Wa10b',
             *     _type: 'chart'
             *   }]
             * }]
             *
             * -> {
             *   'C456a.P5650.W9865': 'table',
             *   'C456a.P5650.Wa10b': 'chart'
             * }
             */
            exports.extractWidgetTypeMap = function (container) {
                var extractFn = function (page, widget) {
                    return {
                        widgetType: widget._type,
                        widgetId: widget._id,
                        pageId: page._id,
                        containerId: container._id
                    };
                };
                var widgets = extractWidgets(container, extractFn);
                var keys = _.map(widgets, utils.makeWidgetKey);
                var values = _.map(widgets, function (widget) {
                    return widget.widgetType;
                });
                return _.zipObject(keys, values);
            };
            exports.setupExports = function ($window, container, selectedPageId) {
                var allRipsawIds = exports.extractRipsawIds(container);
                var selectedRipsawIds = _.filter(allRipsawIds, function (ripsawIds) {
                    return ripsawIds.pageId === selectedPageId;
                });
                var widgetStatusManager = new WidgetStatusManager(selectedRipsawIds);
                var timeoutWidgetHandles;
                $window.genericExports = {
                    prepareForExport: function () {
                        exports.setExportReadyEvent(container);
                        var delay = constants.WIDGET_EXPORT_TIMEOUT; // just less than the generic-exports timeout
                        timeoutWidgetHandles = _(selectedRipsawIds)
                            .map(function (ripsawIds) {
                            var widgetKey = utils.makeWidgetKey(ripsawIds);
                            return [widgetKey, exports.timeoutWidgets(ripsawIds, delay)];
                        })
                            .fromPairs()
                            .value();
                        var widgetEventHandlers = [
                            'viewresults.widgetFullDataComplete',
                            'viewresults.widgetMisconfigured',
                            'viewresults.widgetError'
                        ];
                        _.each(widgetEventHandlers, function (event) {
                            $rootScope.$on(event, function (evt, widgetId, pageId, containerId) {
                                var ripsawIds = {
                                    widgetId: widgetId,
                                    pageId: pageId,
                                    containerId: containerId
                                };
                                var widgetKey = utils.makeWidgetKey(ripsawIds);
                                var timeoutWidgetHandle = timeoutWidgetHandles[widgetKey];
                                if (timeoutWidgetHandle) {
                                    $timeout.cancel(timeoutWidgetHandle);
                                }
                            });
                        });
                    },
                    checkReady: function () {
                        var isReady = widgetStatusManager.isReady() && exports.areImagesLoaded();
                        if (isReady && timeoutWidgetHandles !== undefined) {
                            _.each(timeoutWidgetHandles, function (handle) {
                                $timeout.cancel(handle);
                            });
                        }
                        return isReady;
                    }
                };
            };
            exports.areImagesLoaded = function () {
                var images = Array.from(document.querySelectorAll('img'));
                return _.every(_.map(images, 'complete'));
            };
            exports.timeoutWidgets = function (ripsawIds, delay) {
                // Start timer to execute a phantom screenshot irrespective of the
                // state the widget is in, if there has not been any event from the widget
                // for delay
                var widgetTimeoutHandler = $timeout(function () {
                    $rootScope.$emit('viewresults.widgetNotReadyForScreenshot', ripsawIds);
                }, delay);
                return widgetTimeoutHandler;
            };
            exports.setExportReadyEvent = function (container) {
                var widgetTypeMap = exports.extractWidgetTypeMap(container);
                // these widgets emit more than one `widgetFullDataRendered` event per widget if there is a breakout
                var multiChartWidgetsTypeClassMap = {
                    'viewresults.gauge': 'gauge-wrapper',
                    'viewresults.pie': 'single-pie-wrapper',
                    'viewresults.simpletable': 'aggregate-container'
                };
                function emitFullDataComplete(widgetId, pageId, containerId) {
                    $rootScope.$emit('viewresults.widgetFullDataComplete', widgetId, pageId, containerId);
                }
                function delayRender(widgetId, pageId, containerId) {
                    var ripsawIds = _.zipObject(['widgetId', 'pageId', 'containerId'], [widgetId, pageId, containerId]);
                    var widgetType = widgetTypeMap[utils.makeWidgetKey(ripsawIds)];
                    if (multiChartWidgetsTypeClassMap[widgetType]) {
                        delayUntilWidgetFullyRendered(widgetId, pageId, containerId, 0, 0, multiChartWidgetsTypeClassMap[widgetType]);
                    }
                    else {
                        var timeout = getTimeoutForWidgetType(widgetType);
                        _.delay(emitFullDataComplete, timeout, widgetId, pageId, containerId);
                    }
                }
                function delayUntilWidgetFullyRendered(widgetId, pageId, containerId, lastCount, numTries, widgetClass) {
                    var goodEnough = 5;
                    var children = angular.element('div#' + widgetId).find('div.widget-contents').find('div.' + widgetClass);
                    if (children) {
                        if (children.length == lastCount && numTries == goodEnough) {
                            return emitFullDataComplete(widgetId, pageId, containerId);
                        }
                        else if (children.length == lastCount) {
                            _.delay(delayUntilWidgetFullyRendered, 500, widgetId, pageId, containerId, lastCount, numTries + 1, widgetClass);
                        }
                        else {
                            _.delay(delayUntilWidgetFullyRendered, 500, widgetId, pageId, containerId, children.length, 0, widgetClass);
                        }
                    }
                    else {
                        _.delay(delayUntilWidgetFullyRendered, 500, widgetId, pageId, containerId, lastCount, 0, 0, widgetClass);
                    }
                }
                function getTimeoutForWidgetType(widgetType) {
                    // CPR-5832
                    if (widgetType === 'eng.grid') {
                        return 1000;
                    }
                    return 1;
                }
                $rootScope.$on('viewresults.widgetFullDataRendered', function (evt, widgetId, pageId, containerId) {
                    delayRender(widgetId, pageId, containerId);
                });
            };
            return exports;
        }
    ]);
})(angular.module('reporting.dashboards.services'));
